export default "__VITE_ASSET__Cd_xT87G__"